<template>
    <!--TODO: on category or location click it should make it active in filters-->
    <table :class="`table--${theme}`">
        <thead>
        <tr>
            <td>JOB TYPE ></td>
            <td>PROJECT ></td>
            <td>DISCIPLINES ></td>
            <td>LOCATION ></td>
        </tr>
        </thead>
        <tbody>
        <router-link :to="{name: POSITION_PAGE_NAME, params: {slug: item.slug}}" v-for="item in list" tag="tr"
                     :key="item.id">
            <td class="title">
                <h4>
                    {{item.title}}
                </h4>
            </td>
            <td class="project"><span v-if="item.project">{{item.project.title}}</span><span
                    v-else>Unannounced</span>
            </td>
            <td class="category">
                <template v-for="(department, index) in item.departments">
                    <template v-if="index > 0">,</template>
                    <span :key="department.id">{{department.name}}</span>
                </template>
            </td>
            <td class="location"><span>{{item.location.city}}, {{item.location.country}}</span></td>
            <td class="fake-height">
                <div>&nbsp;</div>
            </td>
        </router-link>
        </tbody>
    </table>
</template>

<script>
  import { POSITION_PAGE_NAME } from "../../router/pageConstants";

  export default {
    name: "jobs-table",
    props: {
      list: Array,
      theme: String
    },
    data() {
      return {
        POSITION_PAGE_NAME
      };
    }
  };
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/globals";

    table {
        width: 100%;
        max-width: 100%;
        background-color: transparent;
        font-family: $font-paragraphs;
        border-collapse: collapse;
    }

    .table--primary {
        thead {
            color: $primary;
        }
    }

    .table--blue {
        thead {
            color: $text-blue;
        }
    }

    thead {
        font-size: 12px;
        letter-spacing: 1.2px;

        @media (max-width: $mq-xs-max) {
            display: none;
        }

        td {
            padding: 40px 0;

            @media (max-width: $mq-sm-max) {
                padding-bottom: 0;
            }
        }
    }

    tbody {
        font-weight: 900;
        font-size: 16px;

        tr {
            color: #9c9c9c;
            transition: color 0.6s;
            border-bottom: 1px solid #E7E6E6;
        }

        tr:hover {
            cursor: pointer;
            color: $god-gray;
        }

        td {
            padding: 35px 50px 30px 0;

            @media (max-width: $mq-sm-max) {
                // last-child is fake-height element
                // so we need to reset padding in the child before last one
                &:nth-last-child(2) {
                    padding-right: 0;
                }
            }

            @media (max-width: $mq-xs-max) {
                display: block;
                padding: 0;
            }
        }
    }

    tr {
        @media (max-width: $mq-xs-max) {
            display: block;
            padding: 20px 0;
        }
    }

    td {
        h4 {
            font-size: 22px;
            font-weight: 900;
            margin: 0;
            font-family: inherit;
            // TODO: add text-overflow for a bigger screens

            @media (max-width: $mq-xs-max) {
                margin-bottom: 10px;
            }
        }

        &.title {
            color: $darker-gray;
            transition: color 0.6s;
            width: 40%;

            &:hover {
                color: $god-gray;
            }
        }

        &.category {
            width: 25%;

            @media (min-width: $mq-lg-min) {
                padding-right: 110px;
            }
        }

        &.location {
            width: 20%;
        }

        &.project {
            width: 15%;
        }

        &.title,
        &.category,
        &.location {
            @media (max-width: $mq-xs-max) {
                width: auto;
            }
        }

        &.fake-height {
            padding: 0;
            width: 0;

            div {
                min-height: 127px;
            }

            @media (max-width: $mq-xs-max) {
                display: none;
            }
        }
    }

    a {
        color: #444;

        &:hover {
            color: $text-weak;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobsTable.vue